import * as React from 'react';
import { ImageField, Show, ShowProps, SimpleShowLayout, TextField, UrlField } from 'react-admin';
import { TranslateField } from '../components/TranslateField';

export const DynamicCardShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<ImageField source="imageUrl" label="IMAGE"/>
				<TextField source="name" label="NAME"/>
				<UrlField source="link" label="LINK"/>
				{/*<TextField source="description" label="DESCRIPTION"/>*/}
				<TranslateField source="language" label="LANGUAGE"/>
			</SimpleShowLayout>
		</Show>
	);
};
